import React, { Suspense, useLayoutEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { RedirectAs404 } from "../utils";

import Faq from "../pages/others/Faq";
import Terms from "../pages/others/Terms";
import Dashboard from "../pages/tabs/dashboard/Dashboard";
import CarerList from "../pages/tabs/carers/CarerList";
import Wage from "../pages/tabs/invoices/Wage";
import UserList from "../pages/tabs/others/users/UserList";
import GradeList from "../pages/tabs/others/grade/GradeList";
import SpecialityList from "../pages/tabs/others/speciality/SpecialityList";
import HolidayList from "../pages/tabs/others/holiday/HolidayList";
import UserRoleList from "../pages/tabs/others/user-role/UserRoleList";
import NoteTypeList from "../pages/tabs/others/note-type/NoteTypeList";
import BranchList from "../pages/tabs/others/branch/BranchList";
import Rotas from "../pages/tabs/rotas/Rotas";
import AddUserRole from "../pages/tabs/others/user-role/AddUserRole";
import AddCarer from "../pages/tabs/carers/AddCarer";
import AddJob from "../pages/tabs/jobs/AddJob";
import AddNotes from "../pages/tabs/notes/AddNote";
import DocumentTypeList from "../pages/tabs/others/document-type/DocumentTypeList";
import CarerTypeList from "../pages/tabs/others/carer-type/CarerTypleList";
import AddTrust from "../pages/tabs/clients/trust/AddTrust";
import AddHospital from "../pages/tabs/clients/hospital/AddHospital";
import HospitalDetail from "../pages/tabs/clients/hospital/HospitalDetail";
import TrustList from "../pages/tabs/clients/trust/TrustList";
import HospitalList from "../pages/tabs/clients/hospital/HospitalList";
import Job from "../pages/tabs/jobs/Job";
import Invoice from "../pages/tabs/invoices/Invoice";
import CarerDetails from "../pages/tabs/carers/CarerDetails";
import Sms from "../pages/tabs/sms/Sms";
import JobDetail from "../pages/tabs/jobs/JobDetail";
import InvoiceEmail from "../pages/tabs/invoices/invoiceEmail/InvoiveEmail";
import Template from "../pages/tabs/others/template/Template";
import VerifyPassword from "../pages/auth/CheckPassword";
import CreatePassword from "../pages/auth/CreatePassword";
import AgencyList from "../pages/tabs/others/agency/AgencyList";
import AddAgency from "../pages/tabs/others/agency/AddAgency";
import TimesheetNew from "../pages/tabs/timesheets/TimesheetNew";
import JobAuditTrail from "../pages/tabs/jobs/JobAuditTrail";
import CarerDocList from "../pages/tabs/dashboard/CarerDocList";
import AddCustomInvoice from "../pages/tabs/invoices/AddCustomInvoice";
import LoginActivity from "../pages/auth/LoginActivity";
import BroadCast from "../layout/header/SendBroadCast/BroadCast";
import InvoiceAuditDetail from "../pages/tabs/invoices/invoiceEmail/InvoiceAuditDetail";
import SageReferenceList from "../pages/tabs/others/sage-reference/SageReferenceList";
// import DocumentTypeList from "../pages/tabs/others/document-type/DocumentTypeList";

import Availabilitilist from "../pages/tabs/others/availabilities/AvailabilitiList";
import ReportList from "../pages/tabs/reports/ReportList";
import TimesheetReport from "../pages/tabs/reports/TimesheetReport";
import AddReport from "../pages/tabs/reports/AddReport";
import NmcList from "../pages/tabs/others/nmc/NmcList";
import NisccList from "../pages/tabs/others/niscc/NisccList";

const Pages = () => {
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  });

  return (
    <Suspense fallback={<div />}>
      <Routes>
        <Route path={`${process.env.PUBLIC_URL}/`} element={<Navigate to={`${process.env.PUBLIC_URL}/rotas`} replace />} />
        <Route path={`${process.env.PUBLIC_URL}/dashboard`} element={<Dashboard />} />
        <Route path={`${process.env.PUBLIC_URL}/carer-document-list`} element={<CarerDocList />} />

        <Route path={`${process.env.PUBLIC_URL}/clients`} element={<HospitalList />} />
        <Route path={`${process.env.PUBLIC_URL}/client-detail`} element={<HospitalDetail />} />
        <Route path={`${process.env.PUBLIC_URL}/carers`} element={<CarerList />} />
        <Route path={`${process.env.PUBLIC_URL}/trusts`} element={<TrustList />} />
        <Route path={`${process.env.PUBLIC_URL}/add-carer`} element={<AddCarer />} />
        <Route path={`${process.env.PUBLIC_URL}/carer-detail`} element={<CarerDetails />} />

        <Route path={`${process.env.PUBLIC_URL}/jobs`} element={<Job />} />
        <Route path={`${process.env.PUBLIC_URL}/add-job`} element={<AddJob />} />
        <Route path={`${process.env.PUBLIC_URL}/job-detail`} element={<JobDetail />} />
        <Route path={`${process.env.PUBLIC_URL}/job-audit-trail`} element={<JobAuditTrail />} />

        <Route path={`${process.env.PUBLIC_URL}/rotas`} element={<Rotas />} />
        <Route path={`${process.env.PUBLIC_URL}/timesheets`} element={<TimesheetNew />} />

        <Route path={`${process.env.PUBLIC_URL}/wages`} element={<Wage />} />
        <Route path={`${process.env.PUBLIC_URL}/invoices`} element={<Invoice />} />
        <Route path={`${process.env.PUBLIC_URL}/invoices-email`} element={<InvoiceEmail />} />
        <Route path={`${process.env.PUBLIC_URL}/add-invoice`} element={<AddCustomInvoice />} />
        <Route path={`${process.env.PUBLIC_URL}/invoice-audit-detail`} element={<InvoiceAuditDetail />} />

        <Route path={`${process.env.PUBLIC_URL}/reports/clients`} element={<HospitalList />} />
        <Route path={`${process.env.PUBLIC_URL}/reports/clients/reports-list`} element={<ReportList />} />
        <Route path={`${process.env.PUBLIC_URL}/reports/active-clients`} element={<HospitalList />} />
        <Route path={`${process.env.PUBLIC_URL}/reports/active-clients/reports-list`} element={<ReportList />} />
        <Route path={`${process.env.PUBLIC_URL}/add-report`} element={<AddReport />} />
        <Route path={`${process.env.PUBLIC_URL}/reports/carers`} element={<CarerList />} />
        <Route path={`${process.env.PUBLIC_URL}/reports/carers/reports-list`} element={<ReportList />} />
        <Route path={`${process.env.PUBLIC_URL}/reports/active-carers`} element={<CarerList />} />
        <Route path={`${process.env.PUBLIC_URL}/reports/active-carers/reports-list`} element={<ReportList />} />
        <Route path={`${process.env.PUBLIC_URL}/reports/timesheets`} element={<TimesheetReport />} />

        <Route path={`${process.env.PUBLIC_URL}/area-managers`} element={<BranchList />} />
        <Route path={`${process.env.PUBLIC_URL}/users`} element={<UserList />} />
        <Route path={`${process.env.PUBLIC_URL}/agencies`} element={<AgencyList />} />
        <Route path={`${process.env.PUBLIC_URL}/add-agency`} element={<AddAgency />} />

        <Route path={`${process.env.PUBLIC_URL}/grades`} element={<GradeList />} />
        <Route path={`${process.env.PUBLIC_URL}/specialities`} element={<SpecialityList />} />
        <Route path={`${process.env.PUBLIC_URL}/holidays`} element={<HolidayList />} />
        <Route path={`${process.env.PUBLIC_URL}/roles`} element={<UserRoleList />} />
        <Route path={`${process.env.PUBLIC_URL}/add-userrole`} element={<AddUserRole />} />
        <Route path={`${process.env.PUBLIC_URL}/note-types`} element={<NoteTypeList />} />
        <Route path={`${process.env.PUBLIC_URL}/carer-types`} element={<CarerTypeList />} />
        <Route path={`${process.env.PUBLIC_URL}/document-types`} element={<DocumentTypeList />} />
        <Route path={`${process.env.PUBLIC_URL}/availabilities`} element={<Availabilitilist />} />
        <Route path={`${process.env.PUBLIC_URL}/nmc`} element={<NmcList />} />
        <Route path={`${process.env.PUBLIC_URL}/niscc`} element={<NisccList />} />

        <Route path={`${process.env.PUBLIC_URL}/add-notes`} element={<AddNotes />} />
        <Route path={`${process.env.PUBLIC_URL}/sms`} element={<Sms />} />
        <Route path={`${process.env.PUBLIC_URL}/add-trust`} element={<AddTrust />} />
        <Route path={`${process.env.PUBLIC_URL}/add-client`} element={<AddHospital />} />
        <Route path={`${process.env.PUBLIC_URL}/templates`} element={<Template />} />
        <Route path={`${process.env.PUBLIC_URL}/template1`} element={<Template />} />
        <Route path={`${process.env.PUBLIC_URL}/sage-references`} element={<SageReferenceList />} />
        <Route path={`${process.env.PUBLIC_URL}/check-password`} element={<VerifyPassword />} />
        <Route path={`${process.env.PUBLIC_URL}/change-password`} element={<CreatePassword />} />
        <Route path={`${process.env.PUBLIC_URL}/login-activity`} element={<LoginActivity />} />
        <Route path={`${process.env.PUBLIC_URL}/broadcast`} element={<BroadCast />} />

        <Route path={`${process.env.PUBLIC_URL}/pages/terms-policy`} element={<Terms />} />
        <Route path={`${process.env.PUBLIC_URL}/pages/faq`} element={<Faq />} />
        <Route path="*" element={<RedirectAs404 />} />
      </Routes>
    </Suspense>
  );
};
export default Pages;
